module.exports = __WEBPACK_EXTERNAL_MODULE_https_app_dev_joymenus_com_remoteEntry_mjs_220209fc__;